import React, { ReactNode } from "react";
import { styled, Box, Typography, Grid2, SxProps } from "@mui/material";

const PropBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.subtle,
  borderRadius: theme.shape.borderRadius,
  height: "100%",
  border: `1px solid ${theme.palette.border.secondary}`,
  padding: theme.spacing(1, 3),
}));

const Card = ({
  totalCards,
  label,
  value,
  isSmallerFontSize = false,
  icon,
}: {
  totalCards: number;
  label: string;
  value: string;
  isSmallerFontSize: boolean;
  icon?: ReactNode;
}) => {
  const cardWidth = 12 / totalCards;
  return (
    <Grid2
      size={{
        xs: 12,
        sm: cardWidth,
      }}
    >
      <PropBox>
        <Typography variant="body3" color="textSecondary">
          {label}
        </Typography>
        <Box display="flex" alignItems="center" gap={1.5}>
          {icon}
          <Typography variant={isSmallerFontSize ? "body2" : "body1"}>
            {value}
          </Typography>
        </Box>
      </PropBox>
    </Grid2>
  );
};

type Props = {
  cards: {
    label: string;
    value: string;
    icon?: ReactNode;
  }[];
  isSmallerFontSize?: boolean;
  containerSx?: SxProps;
};

export const DetailCards = ({
  cards,
  isSmallerFontSize = false,
  containerSx,
}: Props) => {
  return (
    <Grid2
      container
      spacing={3}
      sx={{
        mb: 7,
        ...containerSx,
      }}
    >
      {cards.map((card) => (
        <Card
          key={card.label}
          totalCards={cards.length}
          label={card.label}
          value={card.value}
          isSmallerFontSize={isSmallerFontSize}
          icon={card.icon}
        />
      ))}
    </Grid2>
  );
};
